import React from 'react';
import StatCard from '../../../Components/StatCard/StatCard';

function ProductStats() {
    return (
        <div className="grid grid-cols-4 gap-x-3 mx-5 mt-4">
            <StatCard 
                statName="Last Edited"
                statValue={''}
            />
            <StatCard 
                statName="Available Stock"
                statValue={0}
            />
            <StatCard 
                statName="Inventory Turnover Rate"
                statValue={0}
                hasDecimal={true} 
            />
            <StatCard 
                statName="Average Review Rating"
                statValue={0}
                hasDecimal={true} 
            />
        </div>
    );
}

export default ProductStats;
